import { render, staticRenderFns } from "./BasketCoupon.vue?vue&type=template&id=6cf9523c&"
import script from "./BasketCoupon.vue?vue&type=script&lang=js&"
export * from "./BasketCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports